<template>
	<div class="row m-0 h-100">
		<div class="form-section col-md-4 col-lg-3 p-0 m-0 h-100">
			<div class="h-100 flex-column d-flex position-relative">
				<div class="search-bar-container d-flex">
                    <div class="search-bar flex-1">
						<v-text-field @keyup.enter="getSearch" v-model="message" solo clearable prepend-inner-icon="mdi-magnify" 
                             @click:prepend-inner="getSearch" @click:clear="clearSearch" :placeholder="$t('res_Label_SearchPlaceHolder')">
						</v-text-field>
					</div>
					<div>
                        <v-menu :left="isLanguageEn" :right="!isLanguageEn" attach offset-y :close-on-click="true" 
                            :close-on-content-click="false" :value="shown" content-class="filter-form-container">
                            <template v-slot:activator="{ on, attrs }">
								<div class="custom-icon-wrapper">
									<v-icon v-bind="attrs" v-on="on" @click="shown = true">custom-icon filter-icon</v-icon>
								</div>
                            </template>
                            <v-form class="d-flex flex-column">
								<h3 class="main-text-large">{{ $t("res_MenuItems_Filter") }}</h3>
								<div>
									<label class="main-text-large">{{ $t("res_Label_Category") }}</label>
									<multi-select class="light-bg add-arrow" v-model="filter_category" label="name" track-by="id" open-direction="bottom" :options="categories" 
                                        :searchable="false" :internal-search="false" :clear-on-select="false" :close-on-select="true" :options-limit="300" 
                                        :max-height="600" :show-no-results="false" :hide-selected="false" :multiple="false" ref="multiselect1" 
                                        :placeholder="$t('res_Label_Select')">
										<template slot="noOptions" slot-scope="props">
											{{$t("res_Msgs_EmptySearch")}}
										</template>
									</multi-select>
								</div>
								<div>
									<label>{{ $t("res_MenuItems_ReferenceNumber") }}</label>
									<v-text-field solo v-model="filter_reference_number" :placeholder="$t('res_Label_defaultTextValue')"></v-text-field>
								</div>
								<div>
									<label>{{ $t("res_GridHeaders_Created_ReceivedDate") }}</label>
                                    <v-menu offset-y content-class="p-0" v-model="created_date_datePicker" :close-on-content-click="false">
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-text-field :value="utils.dateFormat(filter_created_date)"  label="" readonly v-bind="attrs" v-on="on" solo append-icon="mdi-calendar" :placeholder="constants.defaultDateValue">
                                                <template v-slot:append>
                                                    <v-icon v-bind="attrs" v-on="on">mdi-calendar</v-icon>
                                                </template>
                                            </v-text-field>
                                        </template>
                                        <v-date-picker v-model="filter_created_date" @input="created_date_datePicker = false"></v-date-picker>
                                    </v-menu>
								</div>
								<div class="form-actions">
									<v-btn @click="clearFilters">{{ $t("res_ButtonText_Clear") }}</v-btn>
									<v-btn class="text-primary" @click="applyFilters">{{ $t("res_ButtonText_Apply") }}</v-btn>
								</div>
							</v-form>
                        </v-menu>
					</div>
				</div>

                <div class="linked-mails-list overflow-auto flex-1">
					<div       :class="{ 'linked-mails-item light-blue-bg': selectedDocument && selectedDocument.id==item.id, 'linked-mails-item light-blue-hover': selectedDocument==null || selectedDocument?.id!=item.id }"       class="linked-mails-item light-blue-hover" v-for="(item, i) in items" :key="i">
						<div class="d-flex align-items-center">
							<v-checkbox v-model="resultCheckbox" :value="item" :key="item.id"></v-checkbox>
							<div class="flex-1 d-flex flex-column" @click="previewItem(item)">
								<div class="d-flex align-items-center">
									<h3 class="mb-0 flex-1">{{ item.subject }}</h3>
                                    <span v-if="item.isoverdue" style="color:red"><v-icon style="color: red;">mdi-overdue</v-icon></span>
								</div>
								<div class="d-flex align-items-center">
									<p class="flex-1 m-0">{{ item.referenceNumber }} - {{ item.sendingEntity }}</p>
									<span class="text-small">{{ utils.formatDateTime(item.createdDate) }}</span>
								</div>
								<div class="labels d-flex align-items-center">
									<v-chip dark :class="'' + constants.statusesEnum.getById(item.statusId).data().classColor + ''">{{ item.status }}</v-chip>
									<span class="text-small flex-1 d-flex align-items-center">{{ item.categoryName }}</span>
									<span v-if="item.attachmentId !== null"><v-icon>mdi-attachment</v-icon></span>
								</div>
							</div>
						</div>
					</div>
                    <div v-if="allowCorrespondenceItemsLoadMore">
                        <InfiniteLoading @infinite="loadMoreCorrespondences" ref="infiniteCorrespondencesLoader">
                            <div slot="spinner">Loading...</div>
                            <div slot="no-more"></div>
                            <div slot="no-results"></div>
                        </InfiniteLoading>
                    </div>
				</div>
            </div>
        </div>

        <div class="viewer-wrapper col-md-8 col-lg-9 h-100 p-0 m-0 h-100">
			<div class="d-flex flex-column h-100">
				<div class="p-0 scrollable-container flex-1">
					<div v-if="empty_viewer" class="empty-viewer">
                        <img  src="assets/images/icons/template.svg" />
						<h2>{{ heading }}</h2>
						<p>{{ text }}</p>
					</div>
					<div v-if="multi_viewer" class="empty-viewer">
                        <img class="multi-preview-img" src="assets/images/icons/multiple-selection.svg" />
						<h2>{{ heading }}</h2>
						<p>{{ text }}</p>
					</div>
					<div v-if="viewer" id="viewer_template" class="h-100"> 
                        <iframe :src="viewerFrameSrc" class="h-100 w-100"></iframe>
					</div>
				</div>
				<div class="dialog-footer sticky-footer top-shadow p-3 d-flex align-items-center justify-content-end gap-3 position-relative">
					<v-btn color="light-blue" @click="closeSelectLinkedDocumentPopup()">{{ $t("res_ButtonText_Cancel") }}</v-btn>
					<v-btn class="primary" :disabled="resultCheckbox.length < 1" @click="addLinkedDocument()">{{ $t("res_ButtonText_Add") }}</v-btn>
				</div>
			</div>
		</div>
    </div>
</template>

<script>
    import { defaultGet, defaultPost } from '@/assets/js/common.js'
    import constants from '@/assets/js/constants.js'
    import axios from 'axios'
    import MultiSelect from 'vue-multiselect'
    import * as utils from '@/assets/js/common.js'
    import InfiniteLoading from 'vue-infinite-loading' 
     export default {
        name: 'LinkedDocument',
        components: { MultiSelect, InfiniteLoading },
        props: {
            refreshToken: { type: String, default: '' },
        },
        data() {
            return {
                message: '',
                empty_viewer: true,
                multi_viewer: false,
                isLanguageEn: true,
                shown: false,
                viewer: false,
                loading: false,
                created_date_datePicker: false,
                search: '',
                selectedAttachmentId: 0,
                selectedTemplate: {},
                items: [],
                allowCorrespondenceItemsLoadMore: false,
                totalRecords: 0,
                selectedDocuments: [],
                selectedDocument:null,
                allLinkedDocuments: [],
                statuses: [],
                purpose_items: [],
                resultCheckbox: [],
                documentAttachments: [],
                linkedDocuments: [],
                selectedItems: [],
                categories: [],
                openPreviewPane: false,
                heading: "No mail is Selected",
                text: "Select a mail to view it",
                filter_reference_number: '',
                filter_created_date: '',
                filter_category: null,
                trueCount: 0,
                pageSize: 20,
                from: 0,
                utils: utils,
                viewerFrameSrc: '',
                constants: constants
                
            };
        },
        props:
        {
            documentId: { type: Number, default: 0 },
            dialogModelShow: { type: Boolean, default: false },
        },
        watch:
        {

           dialogModelShow(newVal, oldVal) 
            {
                if (newVal != oldVal) 
                {
                    if (newVal == true) 
                    {
                        this.getLinkedDocuments("")
                        this.getConstantData()
                        this.getPurposes()
                    }
                    else 
                    {
                        this.heading = window.translate("res_Msgs_NoEmailSelection")
                        this.text = window.translate("res_Msgs_SelectEmail")
                        this.items = [];
                        this.resultCheckbox = [];
                        this.documentAttachments = [];
                    }
                }
            },
            resultCheckbox(newVal, oldVal) 
            {
                if (newVal != oldVal) 
                {
                    if (this.selectedDocument!=null) 
                    {
                        var documentItem = this.selectedDocument
                        if (documentItem != null && documentItem != undefined && documentItem.attachmentId != null && documentItem.attachmentId != undefined) {

                            // this.viewerFrameSrc = constants.viewerUrl + '?id=' + documentItem.attachmentId + '&documentId=' + this.documentId + 
                            //     '&token=' + sessionStorage.getItem('jwt_token') +'&lang='+ this.$i18n.locale +  '&defaultScale=page-width&pageMode=view' + 
                            //     '&viewerMode=collapsed&r=' + new Date().getTime();

                            window.setViewerData(documentItem.attachmentId , documentItem.id);
                            this.viewerFrameSrc =  '/resources/viewer/viewer.html?lang='+ this.$i18n.locale +  '&defaultScale=page-width&pageMode=view' + 
                                '&viewerMode=collapsed&r=' + new Date().getTime();
                          
                            this.empty_viewer = false
                            this.multi_viewer=false
                            this.viewer = true
                        }
                    }
                    else if (this.resultCheckbox.length == 0) 
                    {
                        this.documentAttachments = []
                        this.empty_viewer = true
                        this.multi_viewer=false
                        
                        this.viewer = false
                        this.heading = window.translate("res_Msgs_NoEmailSelection")
                        this.text = window.translate("res_Msgs_SelectEmail")
                    }
                    else if (this.resultCheckbox.length == 1) 
                    {
                        this.selectedDocument=null
                        var documentItem = this.resultCheckbox[0]
                        if (documentItem != null && documentItem != undefined && documentItem.attachmentId != null && documentItem.attachmentId != undefined) {

                            // this.viewerFrameSrc = constants.viewerUrl + '?id=' + documentItem.attachmentId + '&documentId=' + documentItem.id + 
                            //     '&token=' + sessionStorage.getItem('jwt_token') +'&lang='+ this.$i18n.locale +  '&defaultScale=page-width&pageMode=view' + 
                            //     '&viewerMode=collapsed&r=' + new Date().getTime();
                             
                            window.setViewerData(documentItem.attachmentId , documentItem.id);
                            this.viewerFrameSrc =  '/resources/viewer/viewer.html?lang='+ this.$i18n.locale +  '&defaultScale=page-width&pageMode=view' + 
                                '&viewerMode=collapsed&r=' + new Date().getTime();
                            
                            this.empty_viewer = false
                            this.multi_viewer=false
                        
                            this.viewer = true
                        }
                        else 
                        {
                            this.empty_viewer = true
                            this.viewer = false
                            this.multi_viewer=false
                        
                            this.heading = window.translate("res_Msgs_LinkedMailContainNoAttachment")
                            this.text = window.translate("res_Msgs_SelectDifferentEmail")
                        }
                    }

                    if (this.resultCheckbox.length > 1) 
                    {
                        this.selectedDocument=null
                        this.empty_viewer = false
                        this.multi_viewer=true
                        this.viewer = false
                        this.heading = this.resultCheckbox.length + " " + window.translate("res_Msgs_selected")
                        // this.text = window.translate("res_Msgs_RemoveMultipleSelection")
                        this.text = window.translate("res_Msgs_SelectActionForSelection")
                    }
                }
            }
        },
        mounted: function () 
        {
            this.heading = window.translate("res_Msgs_NoEmailSelection")
            this.text = window.translate("res_Msgs_SelectEmail")

            this.getConstantData()
            this.getPurposes()
            this.getLinkedDocuments("")

            this.categories =  this.constants.categories.filter(x=>
                x.id== this.constants.categoriesEnum.Incoming ||
                x.id== this.constants.categoriesEnum.Outgoing ||
                x.id== this.constants.categoriesEnum.Internal ||
                x.id== this.constants.categoriesEnum.Circular ||
                x.id== this.constants.categoriesEnum.Decree
            )
        },
        methods:
        {
            previewItem(item)
            {
                //this.resultCheckbox = []
             //   this.resultCheckbox.push(item)
          
             this.selectedDocument = item;
                        if (this.selectedDocument != null && this.selectedDocument != undefined && this.selectedDocument.attachmentId != null && this.selectedDocument.attachmentId != undefined) {

                            this.viewerFrameSrc = constants.viewerUrl + '?id=' + this.selectedDocument.attachmentId + '&documentId=' + this.documentId + 
                                '&token=' + sessionStorage.getItem('jwt_token') +'&lang='+ this.$i18n.locale +  '&defaultScale=page-width&pageMode=view' + 
                                '&viewerMode=collapsed&r=' + new Date().getTime();
                            this.empty_viewer = false
                            this.multi_viewer=false
                            this.viewer = true
this.resultCheckbox=[];
                        }



            },
            getLinkedDocuments(message) 
            {
                this.allLinkedDocument = [];
                axios.get(constants.baseApiUrl + 'LinkedDocument/GetLinkedDocuments?documentId=' + this.documentId)
                    .then(res => 
                    {
                        this.allLinkedDocuments = []
                        if (res.data != null && res.data != undefined) 
                        {
                            res.data.forEach(element => 
                            {
                                if (element != null && element != undefined)
                                    this.allLinkedDocuments.push(element.linkedDocumentId)
                            })

                            this.getDocumentByFilter(message);
                        }
                    }
                )
            },
            scrollIntoViewer() 
            {
                document.getElementById("viewer_template").scrollIntoView()
            },
            clear() 
            {
                this.message = '';
            },
            clearFilters() 
            {
                this.from = 0;
                this.filter_reference_number = ''
                this.filter_created_date = ''
                this.filter_category = null
                this.shown = false;
                this.getLinkedDocuments(this.message)
            },
            applyFilters() 
            {
                this.totalRecords = 0
                this.allowCorrespondenceItemsLoadMore = false
                this.from = 0
                this.getLinkedDocuments(this.message)
                this.shown = false;
            },
            getConstantData() 
            {
                this.statuses = constants.statuses;
            },
            getPurposes() 
            {
                axios.get(constants.baseApiUrl + 'Document/get-all-purposes')
                    .then(res => 
                    {
                        if (res.data != null && res.data != undefined)
                            this.purpose_items = res.data
                    })
            },
            clearSearch() 
            {
                this.totalRecords = 0
                this.allowCorrespondenceItemsLoadMore = false
                this.from = 0
                this.getLinkedDocuments("")
                this.selectedDocument = null
            },
            getSearch() 
            {
                this.totalRecords = 0
                this.allowCorrespondenceItemsLoadMore = false
                this.from = 0
                this.message = this.message.trim()
                this.message != "" ? this.getLinkedDocuments(this.message) : this.clearSearch() // window.showAlert("Kindly provide any search query", 'warning');
                this.selectedDocument = null;
            },
            getDocumentByFilter(message) 
            {
                var searchData = {
                    Message: message,
                    CategoryId: (this.filter_category != null && this.filter_category != undefined && Object.keys(this.filter_category).length > 0) ? this.filter_category.id : "",
                    CreatedDate: (this.filter_created_date != null && this.filter_created_date != undefined && this.filter_created_date != "") ? this.filter_created_date : "",
                    PriorityId: "",
                    PrivacyId: "",
                    TransferDate: "",
                    TransferToStructure: "",
                    TransferFromStructure: "",
                    AttachmentCreatedDate: "",
                    AttachmentExtension: "",
                    ReferenceNumber: (this.filter_reference_number != null || this.filter_reference_number != '  ') ? this.filter_reference_number : "",
                    From: 0,
                    PageSize: this.pageSize,
                    DocumentsToBeExcluded: this.allLinkedDocuments.concat(this.documentId)
                }

                window.showLoading()
                axios.post(constants.baseApiUrl + "Search/getDocumentforLinkedMail", searchData, { headers: constants.headers })
                    .then((res) => 
                    {
                        this.items = []
                        this.resultCheckbox = []

                        if (res.data.data != '') 
                        {
                            var linkedDocuments = JSON.parse(res.data.data);
                            linkedDocuments.forEach((element) => 
                            { 
                                this.items.push(element);
                            });

                            this.totalRecords = parseInt(res.data.totalRecords)
                            if (this.totalRecords == this.items.length)
                                this.allowCorrespondenceItemsLoadMore = false
                            else
                                this.allowCorrespondenceItemsLoadMore = true
                        }
                        else 
                        {
                            window.showAlert('res_Msgs_ResultNotFound', 'warning')
                        }
                    })
                    .catch((err) => console.warn(err))
                    .finally(() => window.hideLoading());
            },
            loadMoreCorrespondences($state)
            {
                if (this.from != 0 && this.allowCorrespondenceItemsLoadMore == false)
                {
                    $state.complete();
                    return;
                }

                this.from = this.from + this.pageSize;
                var searchData = {
                    Message: this.message,
                    CategoryId: (this.filter_category != null && this.filter_category != undefined && Object.keys(this.filter_category).length > 0) ? this.filter_category.id : "",
                    CreatedDate: (this.filter_created_date != null && this.filter_created_date != undefined && this.filter_created_date != "") ? this.filter_created_date : "",
                    PriorityId: "",
                    PrivacyId: "",
                    TransferDate: "",
                    TransferToStructure: "",
                    TransferFromStructure: "",
                    AttachmentCreatedDate: "",
                    AttachmentExtension: "",
                    ReferenceNumber: (this.filter_reference_number != null || this.filter_reference_number != '  ') ? this.filter_reference_number : "",
                    From: this.from,
                    PageSize: this.pageSize,
                    DocumentsToBeExcluded: this.allLinkedDocuments.concat(this.documentId)
                }

                window.showLoading()
                axios.post(constants.baseApiUrl + "Search/getDocumentforLinkedMail", searchData)
                    .then((res) => 
                    {
                        var linkedDocuments = JSON.parse(res.data.data);
                        linkedDocuments.forEach((element) => 
                        { 
                            this.items.push(element);
                        });

                        if (this.totalRecords == this.items.length)
                            $state.complete()
                        else
                            $state.loaded()

                        if (this.from >= this.totalRecords) 
                            $state.complete()
                    })
                    .catch((err) => console.warn(err))
                    .finally(() => window.hideLoading())
            },
            reset() 
            {
                this.from = 0
                this.allowCorrespondenceItemsLoadMore = false
                this.selectedItems = []
                this.empty_viewer = true
                this.multi_viewer=false
                this.viewer = false
                this.message = ""
                this.items = []
                this.resultCheckbox = []
                this.viewerFrameSrc=''
                this.selectedDocument = null;
 
            },
            closeSelectLinkedDocumentPopup() 
            {
                this.reset()
                this.$emit('closeSelectLinkedDocumentPopup', 0)
            },
            addLinkedDocument() 
            {
                var user = JSON.parse(sessionStorage.getItem("user"))

                this.linkedDocuments = []
                if (Object.keys(this.resultCheckbox).length > 0) 
                {
                    this.resultCheckbox.forEach(selected => 
                    {
                        var linkedDocument = {
                            DocumentId: this.documentId,
                            LinkedDocumentId: selected.id,
                            CreatedByUserId: user.profile.Id,
                            TransferId: selected.transferId
                        }

                        this.linkedDocuments.push(linkedDocument);
                    })

                    var methodUrl = "LinkedDocument/AddLinkedDocuments";
                    axios.post(constants.baseApiUrl + methodUrl, this.linkedDocuments, { headers: constants.headers })
                        .then((res) => 
                        {
                            if (res != null && res.data == 1) 
                            {
                                window.showAlert('res_Msgs_LinkedDocumentAdded', 'success')
                                this.heading = window.translate("res_Msgs_NoEmailSelection"),
                                    this.text = window.translate("res_Msgs_SelectEmail"),
                                    this.closeSelectLinkedDocumentPopup();
                            }

                        })
                        .catch((err) => console.warn(err));
                }
                else 
                {
                    window.showAlert('res_Msgs_SelectAnyEmail', 'warning')
                }
            }
        }
    }
</script>

<style scoped>
    .template_filter_container {
        justify-content: space-between;
        align-items: flex-end;
    }

    .template_card:hover,
    .template_card:focus {
        background-color: #f1f8ff !important
    }

    .template_selected {
        border: 1px solid #205CDF
    }

    .template_card:hover .v-chip.purple,
    .template_card:focus .v-chip.purple {
        background: #fff !important;
        color: #5C068C !important;
    }

    .template_filter {
        flex: 1;
    }
</style>